import { ApiErrorResponse } from '@/api/common/apiErrorResponse.ts'
import { BaseException } from '@/domain/exceptions/baseException.ts'

export class UnknownErrorException extends BaseException {
  constructor(originalError?: ApiErrorResponse) {
    super('Unknown error', { originalError })
  }
}
